import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
  }
  .MuiIconButton-label {
    font-weight: 500;
    font-size: 16px;
    text-decoration: underline;
  }
    /* Tablet-Notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      .MuiIconButton-label {
        font-size: 18px;
      }
    }
    @media screen and (min-width: ${BREAKPOINT.LG}) {
      .MuiIconButton-label {
        font-size: 20px;
      }
    }
`;

export const Wrapper = styled.div`
  position: relative;
  padding: 24px 18px;
  max-width: 616px;
  margin: 0 auto;
  form {
    margin: 8px 0;
  }

  .MuiFormControl-root {
    width: 100%;
    margin: 7px 0;
  }

  .MuiFormControl-root:nth-child(5) {
    width: 49%;
  }

  /* Viewport <= 360px */
  @media screen and (max-width: 359px) {
    .MuiFormControl-root:nth-child(11),
    .MuiFormControl-root:nth-child(12) {
      width: 100% !important;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: center;
  .MuiButtonBase-root.MuiButton-root {
    width: 100% !important;
  }

  .Mui-disabled {
    width: 240px !important;
  }
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    justify-content: end;
    .MuiButtonBase-root.MuiButton-root {
      max-width: 158px;
    }
  }
`;

export const InputWrapper = styled.div`
  position: relative;

  a {
    position: absolute;
    right: 12px;
    top: 18px;
    color: ${COLOR.GREEN_1};
    font-size: 12px;
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
    }
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    a {
      font-size: 14px;
    }
  }
`;

export const BoxOptin = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 24px 0;
  span {
    padding-left: 0;
  }
  label {
    font-size: 16px;
    line-height: 125%;
    /* Tablet-notebook */
    @media screen and (min-width: ${BREAKPOINT.MD}) {
      font-size: 18px;
    }
  }
`;
